import Categories from "./Categories";
import Articles from "./Articles";
import Downloads from "./Downloads";

export default function Homepage(props) {
  return (
    <div className="homepage">
      <section className="homepage-inner">
        <Categories data={props} />
        {/* <section className="articles">
          <div className="articles-posts">
            <div className="articles-posts-popular">
              <Articles
                data={props}
                title="Popular Articles"
                subtitle="Frequently asked questions"
                featured={true}
                limit={6}
                showCategory={true}
              />
            </div>
            <div className="articles-posts-downloads">
              <Downloads
                data={props}
                title="Downloads"
                subtitle="Helpful quicklinks & downloads"
              />
            </div>
          </div>
        </section> */}
      </section>
    </div>
  );
}
